import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Snel(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 343 228",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M243.043 42.412H50.438v135.806h192.605V42.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M148.235 45.013H50.942V165.56l97.332-.039v5.591H45.391V46.023c0-7.921 5.94-6.99 5.94-6.99h96.943v5.98h-.039zm0 0h94.342V165.56l-94.342-.039v5.591h100.903V46.023c0-7.921-6.91-6.99-6.91-6.99h-93.993v5.98zM124.009 177.519h23.255v10.871s-104.397.504-116.743.504c-12.385 0-10.405-13.86-10.405-13.86h101.408c0 2.485 2.485 2.485 2.485 2.485zm46.511 0h-23.256v10.871s104.398.504 116.744.504c12.385 0 10.405-13.86 10.405-13.86H173.005c0 2.485-2.485 2.485-2.485 2.485z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M178.945 50.41h-69.573v47.48h69.573V50.41zM233.842 101.346h-70.738v64.06h70.738v-64.06zM234.308 50.41h-49.773v1.785h49.773V50.41zM234.308 54.563h-49.773v1.786h49.773v-1.786zM234.308 58.718h-49.773v1.785h49.773v-1.785zM234.308 62.872h-49.773v1.785h49.773v-1.785zM234.308 67.026h-49.773v1.785h49.773v-1.785zM234.308 71.18h-49.773v1.786h49.773V71.18zM234.308 75.334h-49.773v1.786h49.773v-1.786zM234.308 79.488h-49.773v1.786h49.773v-1.786zM234.308 83.642h-49.773v1.786h49.773v-1.786zM234.308 87.796h-49.773v1.786h49.773v-1.786zM234.308 91.95h-49.773v1.787h49.773V91.95zM234.308 96.105h-49.773v1.785h49.773v-1.785zM157.631 117.458H58.203v1.786h99.428v-1.786zM157.631 121.612H58.203v1.786h99.428v-1.786zM157.631 125.766H58.203v1.786h99.428v-1.786zM157.631 129.92H58.203v1.786h99.428v-1.786zM157.631 134.075H58.203v1.786h99.428v-1.786zM157.631 138.229H58.203v1.786h99.428v-1.786zM157.631 142.383H58.203v1.786h99.428v-1.786zM157.631 146.537H58.203v1.786h99.428v-1.786zM157.631 150.691H58.203v1.786h99.428v-1.786zM157.631 154.846H58.203v1.786h99.428v-1.786zM157.631 159H58.203v1.785h99.428V159zM157.631 163.153H58.203v1.786h99.428v-1.786zM157.631 101.346H58.203v5.436h99.428v-5.436zM136.86 108.295H58.202v5.436h78.658v-5.436z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8B8",
    d: "M103.454 49.919H57.918V98.3h45.536V49.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M67.879 62.726h25.614v24.19H67.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M318.206 57.786H225.96v126.838h92.246V57.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M249.565 54.835h66.622c6.833 0 6.406 5.125 6.406 5.125v79.434h-5.552v-78.58h-67.514l.038-5.979zm0 134.098h66.622c6.833 0 6.406-5.125 6.406-5.125v-44.414h-5.552v43.987h-67.514l.038 5.552zm-.038-134.098h-20.499c-6.833 0-6.406 5.125-6.406 5.125v79.434h5.551v-78.58h21.392l-.038-5.979zm.038 128.546h-21.392v-43.987h-5.551v44.414s.427 5.125 6.406 5.125h20.926"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M278.412 186.06v-.233c0-.621-.505-1.126-1.126-1.126h-9.357c-.621 0-1.126.505-1.126 1.126v.233c0 .621.505 1.126 1.126 1.126h9.357c.621 0 1.126-.505 1.126-1.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M312.499 65.046h-36.922v38.591h36.922V65.046z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__ch-illustrations-snel-clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    fillRule: "evenodd",
    d: "M248.602 94.032h5.692v-8.538h8.538v-5.692h-8.538v-8.538h-5.692v8.538h-8.539v5.692h8.539v8.538z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M312.227 107.325H233.57v6.561h78.657v-6.561zM270.297 126.698H233.57v1.359h36.727v-1.359zM270.297 129.804H233.57v1.359h36.727v-1.359zM270.297 132.949H233.57v1.359h36.727v-1.359zM270.297 136.055H233.57v1.359h36.727v-1.359zM270.297 139.2H233.57v1.359h36.727V139.2zM270.297 142.306H233.57v1.359h36.727v-1.359zM270.297 145.45H233.57v1.359h36.727v-1.359zM270.297 148.595H233.57v1.359h36.727v-1.359zM270.297 151.701H233.57v1.359h36.727v-1.359zM270.297 154.846H233.57v1.359h36.727v-1.359zM270.297 157.951H233.57v1.359h36.727v-1.359zM270.297 161.096H233.57v1.359h36.727v-1.359zM311.218 126.698H274.49v1.359h36.728v-1.359zM311.218 129.649H274.49v1.359h36.728v-1.359zM311.218 132.6H274.49v1.358h36.728V132.6zM311.218 135.55H274.49v1.359h36.728v-1.359zM311.218 138.5H274.49v1.359h36.728V138.5zM311.218 141.452H274.49v1.358h36.728v-1.358zM311.218 144.402H274.49v1.359h36.728v-1.359zM311.218 147.353H274.49v1.358h36.728v-1.358zM311.218 150.303H274.49v1.359h36.728v-1.359zM311.218 153.254H274.49v1.359h36.728v-1.359zM311.218 156.204H274.49v1.359h36.728v-1.359zM311.218 159.155H274.49v1.359h36.728v-1.359zM311.218 162.105H274.49v1.359h36.728v-1.359zM311.218 165.056H274.49v1.359h36.728v-1.359zM311.218 168.045H274.49v1.359h36.728v-1.359zM311.218 170.996H274.49v1.359h36.728v-1.359zM311.218 173.947H274.49v1.359h36.728v-1.359zM311.218 176.897H274.49v1.359h36.728v-1.359zM303.259 115.75H233.57v6.212h69.689v-6.212zM270.375 163.853h-36.728v13.976h36.728v-13.976z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256.282 106.043h-47.831v81.569h47.831v-81.569z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M233.22 97.968h20.499c6.833 0 6.406 5.125 6.406 5.125v36.727h-5.551v-32.029h-21.392l.038-9.823zm0 91.392h20.499c6.833 0 6.406-5.125 6.406-5.125V139.82h-5.551v43.988h-21.392l.038 5.552zm0-91.392h-20.499c-6.833 0-6.406 5.125-6.406 5.125v36.727h5.552v-32.029h21.392l-.039-9.823zm.039 85.84h-21.392V139.82h-5.552v44.415s-.427 5.125 6.406 5.125h20.499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M226.504 103.908h-.233a1.169 1.169 0 01-1.165-1.165v-.233c0-.621.544-1.164 1.165-1.164h.233c.621 0 1.165.504 1.165 1.164v.233c0 .66-.544 1.165-1.165 1.165zm15.258-1.165v-.233c0-.621-.505-1.164-1.165-1.164h-9.628c-.66 0-1.165.504-1.165 1.164v.233c0 .66.505 1.165 1.165 1.165h9.628c.621 0 1.165-.505 1.165-1.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M251.157 152.167h-36.184v1.591h36.184v-1.591zM251.157 155.506h-36.184v1.592h36.184v-1.592zM251.157 158.805h-36.184v1.592h36.184v-1.592zM251.157 162.144h-36.184v1.592h36.184v-1.592zM251.157 130.386h-36.3v18.791h36.3v-18.791z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__ch-illustrations-snel-clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    fillRule: "evenodd",
    d: "M230.814 128.185h4.269v-6.404h6.403v-4.269h-6.403v-6.404h-4.269v6.404h-6.404v4.269h6.404v6.404z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M231.629 166.259h-16.772v8.114h16.772v-8.114zM251.118 166.259h-16.772v8.114h16.772v-8.114zM251.157 176.509h-36.184v1.592h36.184v-1.592zM251.157 179.499h-36.184v1.591h36.184v-1.591z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__ch-illustrations-snel-clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.768v22.768H0z",
    transform: "translate(240.063 71.264)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__ch-illustrations-snel-clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17.076v17.076H0z",
    transform: "translate(224.41 111.108)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Snel);
export default ForwardRef;